import { observer } from 'mobx-react-lite';
import { useTranslation } from 'next-i18next';
import { useCartStore } from '@features/cart/mobx/context/CartStoreProvider';
import styles from '@features/cart/components/CartNavigationButton/CartNavigationButton.styles';
import Icon from '@components/icons/Icon';
import Button from '@components/Button/Button';
import EcCart from '@components/icons/components/EcCart';
import theme from '@styles/theme';
type PropsType = {
  iconColor: string;
  active: boolean;
  activeOnCartPage?: boolean;
  onCloseMenu?: () => void;
  isDark: boolean;
};
const CartNavigationButton = ({
  iconColor,
  active,
  activeOnCartPage = false,
  onCloseMenu = () => null,
  isDark
}: PropsType) => {
  const {
    t
  } = useTranslation('common');
  const {
    openMiniSideBarCart,
    totalQuantity
  } = useCartStore();
  const handleOpenMiniCart = () => {
    if (active) {
      onCloseMenu();
      openMiniSideBarCart();
    }
  };
  return <Button variant="iconOnly" variantColor="noStyle" onClick={activeOnCartPage ? onCloseMenu : handleOpenMiniCart} addSx={styles.buttonContainer(active)} addClassName="nav_user_panel" cy="BasketQuantity" aria-label={t('cart.cartTitle')}>
      <Icon color={iconColor} hover={isDark ? theme.rawColors.neutralBlack : undefined} size="24px" title={t('cart.cartTitle')}>
        <EcCart />
      </Icon>
      <div className="number-badge" sx={styles.badge(iconColor, totalQuantity)}>
        {totalQuantity}
      </div>
    </Button>;
};
export default observer(CartNavigationButton);